import React, {
  useContext, useState, useEffect, forwardRef,
} from 'react';
import { QuoteContext } from './QuoteProvider';
import { AnimatedTireLogo } from '../LoadingIndicators/AnimatedTireLogo';

// push the loading animation down from the top of the `.cmp-quote` element
// negative `scrollOffsets` indicate that we've scrolled past the header
const overlayTop = (scrollOffset) => {
  if (scrollOffset < 0) {
    return Math.abs(scrollOffset);
  }

  return 0;
};

// subtract the height of the portion of the header that is visible, so that
// the animation is centered within the content area
const overlayHeightModifier = (scrollOffset) => {
  if (scrollOffset < 0) {
    return 0;
  }

  return scrollOffset;
};

const LoadingAnimation = forwardRef((props, quoteRef) => {
  const [scrollOffset, setScrollOffset] = useState(0);
  const { loadState, loadingState } = useContext(QuoteContext);

  useEffect(() => {
    const quoteElement = quoteRef.current;

    if (loadingState === loadState.FINALIZING) {
      // use current scroll position to show the animation in the right spot
      const { top } = quoteElement.getBoundingClientRect();
      setScrollOffset(top);
    }
  }, [loadState, loadingState, quoteRef]);

  if (loadingState === loadState.FINALIZING) {
    return (
      <div
        className="cmp-quote__animation-overlay"
        style={{
          '--overlay-top': `${overlayTop(scrollOffset)}px`,
          '--overlay-height': `calc(100vh - ${overlayHeightModifier(scrollOffset)}px)`,
        }}
      >
        <AnimatedTireLogo />
      </div>
    );
  }

  return null;
});

export { LoadingAnimation };
